// The Helios breakpoints for TypeScript: the `$breakpoint-*` tokens in
// tokens/_spacing.scss, in px. Media queries in Sass read the tokens; image
// `sizes` hints and other media conditions written in TypeScript read these,
// so both move together. The tokens test checks every value against Sass.
export const BREAKPOINTS = {
  xs: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  '2xl': 1540,
} as const

export type Breakpoint = keyof typeof BREAKPOINTS

/** `(min-width: <breakpoint>px)`: the viewport is at least this wide. */
export function minWidth(breakpoint: Breakpoint) {
  return `(min-width: ${BREAKPOINTS[breakpoint]}px)`
}

/** `(max-width: <breakpoint - 1>px)`: the viewport is narrower than this. */
export function maxWidthBelow(breakpoint: Breakpoint) {
  return `(max-width: ${BREAKPOINTS[breakpoint] - 1}px)`
}
